import angular from "angular";

import MainMenuOrganisationsItemComponent from "./main-menu-organisations-item/main-menu-organisations-item.component";
import OrganisationOwnerOrganisationsApi from '../../resources/organisations/organisation-owner-organisations.resource';

export default angular.module("vt-organisation-owner-menu-components.module", [
  OrganisationOwnerOrganisationsApi.name
]).component("vuiMainMenuOrganisationsItem", MainMenuOrganisationsItemComponent);
